import { useState, useCallback } from 'react'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '@cutilei/ui'
import Cropper from 'react-easy-crop'
import AuthService from 'services/auth'
import cutileiApi, { UPLOAD_TIMEOUT } from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import getCroppedImg from 'services/Image'
import FileInput from 'components/Inputs/FileInput'
import MainButton from 'components/Buttons/MainButton'
import SecondaryButton from 'components/Buttons/SecondaryButton'

import {
  Container,
  Form,
  Image,
  SmallImage,
  CropContainer,
  RangeInput,
  InfoText,
  WhiteText,
  ControlsContainer,
  ErrorContainer
} from './styles'

export default function ChangePictureModal ({
  visible,
  title = 'Editar foto',
  onConfirm: handleConfirm,
  onClose
}) {
  const [loading, setLoading] = useState (false)
  const [imageSrc, setImageSrc] = useState (null)
  const [crop, setCrop] = useState ({ x: 0, y: 0 })
  const [zoom, setZoom] = useState (1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState (null)
  const [croppedImage, setCroppedImage] = useState (null)
  const [errorMessage, setErrorMessage] = useState (null)
  const userType = AuthService.getUserType ()
  const user = AuthService.getUser ()
  const businessId = AuthService.getBusinessId ()

  const handleCropComplete = useCallback ((_, croppedAreaPixels) => {
    setCroppedAreaPixels (croppedAreaPixels)
  }, [])

  const showCroppedImage = useCallback (async () => {
    try {
      const croppedImage = await getCroppedImg (imageSrc, croppedAreaPixels)
      setCroppedImage (croppedImage)
    } catch (error) {
      logApiError (error)
    }
  }, [imageSrc, croppedAreaPixels])

  const handleFileSelected = async file => {
    const fileUrl = await readFile (file)
    setImageSrc (fileUrl)
  }

  const readFile = file => {
    return new Promise (resolve => {
      const reader = new FileReader ()
      reader.addEventListener ('load', () => resolve (reader.result), false)
      reader.readAsDataURL (file)
    })
  }

  const handleSubmit = async () => {
    setLoading (true)
    try {
      const formData = new FormData ()
      const url = userType === 'company'
        ? `/companies/${user.id}/profile_picture`
        : `/businesses/${businessId}/profile_picture`

      formData.append ('profile_picture', croppedImage.file, croppedImage.file.name)

      const { data: fileUri } = await cutileiApi.put (url,  formData, {
          // Upload/download nao cabe no timeout padrao: rede movel ruim leva mais que 30 s.
          timeout: UPLOAD_TIMEOUT,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      
      setLoading (false)
      handleConfirm (fileUri)
      handleClose ()
    } catch (error) {
      setLoading (false)
      if (error.response?.data?.message) {
        setErrorMessage (getApiErrorMessage (error))
      }
      logApiError (error)
    }
  }

  const handleClose = () => {
    setImageSrc (null)
    setCroppedAreaPixels (null)
    setCroppedImage (null)
    onClose ()
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Form>
            <InfoText>Foto atual</InfoText>
            <SmallImage src={user.logo} alt='logo'/>
            {!croppedImage && (
              <FileInput
                label={imageSrc ? 'Trocar imagem' : 'Selecionar imagem'}
                onFileSelected={handleFileSelected}
              />
            )}
            {imageSrc && !croppedImage && (
              <Container>
                <InfoText style={{marginTop: 10, marginBottom: 0}}>
                  Recorte a imagem
                </InfoText>
                <CropContainer>
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 4}
                    onCropChange={setCrop}
                    onCropComplete={handleCropComplete}
                    onZoomChange={setZoom}
                  />
                </CropContainer>
                <ControlsContainer>
                  <InfoText>Zoom</InfoText>
                  <RangeInput
                    value={zoom}
                    aria-labelledby='Zoom'
                    onChange={(e) => {
                      setZoom (e.target.value)
                    }}
                  />
                </ControlsContainer>
                <SecondaryButton
                  label='Recortar e prosseguir'
                  onClick={showCroppedImage}
                  width={180}
                />
              </Container>
            )}
            {croppedImage && (
              <Container>
                <Image src={croppedImage.url}/>
                {errorMessage && (
                  <ErrorContainer>
                    <WhiteText>{errorMessage}</WhiteText>
                  </ErrorContainer>
                )}
                <MainButton
                  label='Confirmar alteração'
                  onClick={handleSubmit}
                  disabled={loading}
                  loading={loading}
                  width={180}
                  style={{marginTop: 10, marginBottom: 10}}
                />
                <MainButton
                  label='Descartar imagem'
                  onClick={() => setCroppedImage (null)}
                  dangerous={true}
                  width={180}
                />
              </Container>
            )}
          </Form>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
